export default __webpack_public_path__ + "static/mern-stack-development-company-peerbits-88c57cbd5fd68b04c5a77a49b01632fe.png";